<template>
  <section class="content">
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
      <div class="box box-info">
        <form>
          <div class="p-fluid p-formgrid p-grid p-mt-2">
              <div class="p-field p-col-12 p-md-2">
                <label>Date</label>
                <date-picker  ref="tran" v-model="transactionDate"  valueType="format" v-if="!englishDateEnabled"/>
                <InputMask  mask="9999-12-32" type="text" v-else class="nepali-calendar" id="transactionDate" v-model="transactionDate"/>
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label for="voucher">Voucher</label>
                <InputText v-model="voucherNo" id="voucher" disabled/>
              </div>
            </div>
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-2">
               <label >Account</label>
                <!-- <Dropdown
                  v-model="account"
                  :options="accountMasterList"
                  optionLabel="name"
                 class="dropDown"
                 :filter="true"
                  placeholder="Select Account"
                /> -->
                 <AutoComplete v-model="account" filterMatchMode='contains'
                 :suggestions="filteredAccounts" @complete="searchItem($event)"
                  field="name" ref="itm" @change="nepaliDate">
                 </AutoComplete>
              </div>
              <div class="p-field p-col-12 p-md-1 align-self-end">
                <accountMasterDialog class="btn-btm-0" v-tooltip.top="'Add Account'" @set_account_master="set_account_master"/>
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label  for="drAmount">Debit Amount</label>
                <!-- <input  class="form-control" id="drAmount" v-model="txnAmountDr"
                v-if="txnAmountCr > 0" disabled /> -->
                <InputNumber id="drAmount" bodyStyle="text-align: right" v-model="txnAmountDr"  :minFractionDigits="2" :maxFracionDigits="4"
                 v-if="txnAmountCr > 0" disabled />
                <!-- <input  class="form-control" id="drAmount" v-model="txnAmountDr"
                v-else /> -->
                <InputNumber onfocus="if (this.value === '0.00')
                                this.value = ''" id="drAmount" bodyStyle="text-align: right" v-model="txnAmountDr"  :minFractionDigits="2" :maxFracionDigits="4"
                 v-else />
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label  for="crAmount">Credit Amount</label>
                <!-- <input type="text" class="form-control" id="crAmount" v-model="txnAmountCr"
                 v-if="txnAmountDr > 0 " disabled/> -->
                 <InputNumber id="crAmount" bodyStyle="text-align: right" v-model="txnAmountCr"  :minFractionDigits="2" :maxFracionDigits="4"
                 v-if="txnAmountDr > 0" disabled />
                <!-- <input type="text" class="form-control" id="crAmount" v-model="txnAmountCr"
                 v-else /> -->
                 <InputNumber onfocus="if (this.value === '0.00')
                                this.value = ''" id="crAmount" bodyStyle="text-align: right" v-model="txnAmountCr"  :minFractionDigits="2" :maxFracionDigits="4"
                  v-else />
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label for="shortNarr">Short Narration</label>
                <!-- <input type="text" class="form-control" id="shortNarr" v-model="narration3"/> -->
                <InputText id="shortNarr" v-model="narration3"/>
              </div>

              <div class="p-field p-col-12 p-md-1 p-mt-5 align-self-end" v-if="!account.isBankAccount" >
                <!-- <Button class="p-button-raised p-button-rounded"
                @click.prevent="addTransactionToDTO" :label="!editDTO?'Add':'Update'"/> -->
                <Button class="p-button p-component addNewBtn btn-btm-0"  @click.prevent="addTransactionToDTO" :label="!editDTO?'Add':'Update'" />
              </div>
              <div class="p-field p-col-12 p-md-1 p-mt-5" v-if="!account.isBankAccount" >
              <Button v-show="editDTO" class="p-button-raised p-button-danger"
                @click.prevent="resetAccountDto" label="Cancel"/>
              </div>
            </div>
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-2">
                <label  for="closingBalance" v-if="account.closingBalance >= 0 || account.closingBalance < 0">Cur. Bal:</label>
                <b style="color:red;" v-if="account.closingBalance>0">{{(account.closingBalance).toFixed(2) + ' ' +'Cr'}}</b>

                <b v-else-if="account.closingBalance === 0">
                  {{(account.closingBalance).toFixed(2)}}
                </b>
                <b style="color:green;" v-else-if="account.closingBalance < 0">
                    {{(account.closingBalance).toFixed(2) * (-1)  + ' ' + 'Dr'}}
                </b>
              </div>
              <div class="p-field p-col-12 p-md-2"></div>
               <div class="p-field p-col-12 p-md-2" v-show="account.isBankAccount">
                  <label  for="">Cheque Date</label>
                  <date-picker v-model="chequeDate" valueType="format" v-if="!englishDateEnabled" />
                  <InputMask mask="9999-99-99"  type="text" v-else  class="nepali-calendar" id="chequeDate" v-model="chequeDate"/>
              </div>
              <!-- {{chequeDate}} -->
               <div class="p-field p-col-12 p-md-2" v-show="account.isBankAccount">
                <label for="chequeNo" >Cheque No</label>
                 <InputText id="chequeNo" v-model="chequeNumber"/>
              </div>
              <div class="p-field p-col-12 p-md-1 p-mt-5" v-if="account.isBankAccount">
                <Button type="submit" class="p-button-raised p-button-rounded"
                @click.prevent="addTransactionToDTO" :label="!editDTO?'Add':'Update'"/>
              </div>
              <div class="p-field p-col-12 p-md-1 p-mt-5" v-if="account.isBankAccount">
                <Button type="submit" v-show="editDTO" class="p-button-raised p-button-danger"
                @click.prevent="resetAccountDto" label="Cancel"/>
              </div>
            </div>
        </form>
          <div class="p-field p-col-12 p-md-12">
          <div>
            <div class="jouscroll">
              <table class="table table-bordered ">
                <thead>
                  <tr>
                    <th scope="col">SN</th>
                    <th scope="col">Account Name</th>
                    <th scope="col">Debit Amount</th>
                    <th scope="col">Credit Amount</th>
                    <th scope="col" v-if="this.bank">Cheque Date</th>
                    <th scope="col" v-if="this.cheque">Cheque Number</th>
                    <th scope="col">Short Narration</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody  v-for="(account,index) in transactionDetailDTOList " :key="index">
                  <tr>
                    <td>{{index+1}}</td>
                    <td>{{account.accountMaster.name}}</td>
                    <td style="text-align:right">{{account.drCr == 'D'?account.txnAmount:''}}</td>
                    <td style="text-align:right">{{account.drCr == 'C'?account.txnAmount:''}} </td>
                    <td v-if="bank">{{account.chequeDate}} </td>
                    <td v-if="cheque">{{account.chequeNumber}} </td>
                    <td >{{account.narration3}} </td>
                    <td>
                      <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                      @click="editAccountFromDTO(account, index)"/>
                      <Button v-if="editDTO" icon="pi pi-trash" class="p-button-raised p-button-danger"
                      @click="deleteAccountFromDTO(account,index)" disabled/>
                      <Button v-if="!editDTO" icon="pi pi-trash" class="p-button-raised p-button-danger"
                      @click="deleteAccountFromDTO(account,index)"/>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                <tr>
                  <td colspan="2">Total:</td>
                  <td>{{ drtotal.toFixed(4) }}</td>
                  <td>{{  crTotal.toFixed(4) }}</td>
                  <td>&nbsp;</td>
                  <td colspan="1">Diff Amt:</td>
                  <td colspan="1">
                  <span style="margin-left:2em;color:green;font-size: 12px;"
                v-if="calculation===0">{{ calculation.toFixed(4) }}</span>
          <span v-else style="margin-left:2em;color:red;font-size: 12px;">{{ calculation.toFixed(4) }}</span>
                  </td>        
        </tr>
              </tfoot>
              </table>
            </div>
          </div>
        </div>
        <!-- <hr>
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-3">
              <label class="_drcr" style="margin-left:14em;">Total</label>
            </div>
            <div class="p-field p-col-12 p-md-3">
              <span style="margin-left:12em;color:#3c8dbc;font-size: 12px;">{{drtotal.toFixed(4)}}</span>
            </div>
          <div class="p-field p-col-12 p-md-3">
            <span style="margin-left:5em;color:#3c8dbc;font-size: 12px;">{{crTotal.toFixed(4)}}</span>
         </div>
         <div class="p-field p-col-12 p-md-3">
            <label class="_drcr">Diff Amt</label>
            <span style="margin-left:2em;color:green;font-size: 12px;" v-if="calculation===0">{{calculation.toFixed(4)}}</span>
           <span v-else style="margin-left:2em;color:red;font-size: 12px;">{{calculation.toFixed(4)}}</span>
         </div>
        </div>
         <hr> -->
         <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-3">
            <label for="narration1">Narration</label>
            <TextArea
              id="narration1"
              cols="15"
              rows="6"
              v-model="narration"
            />
          </div>
          <div class="p-field p-col-12 p-md-3"></div>
          <div class="p-field p-col-12 p-md-1 p-pt-6">
            <Button class="p-button-raised p-button-danger" @click="goBack()" v-if="this.creditNote!=undefined" label="Cancel"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-pt-6">
            <Button class="p-button-raised p-button-warning" @click.prevent="reset" v-if="this.creditNote==undefined"
             label="Reset" icon="pi pi-refresh"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-pt-6">
            <Button class="p-button-raised p-button-rounded" icon="pi pi-save"
            @click.prevent="saveCreditNoteEntry" :label="!editing?'Save':'Update'"/>
          </div>
            <div class="p-field p-col-12 p-md-1 p-pt-6">
              <Button class="p-button-raised p-button-info" icon="pi pi-print" label="Print"/>
            </div>
            <div class="p-field p-col-12 p-md-2 p-pt-6">
             <Button class="p-button-raised p-button-secondary" label=" Generate PDF" icon="pi pi-download"/>
           </div>
          </div>
      </div>
<!--    </div>-->
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import Checkbox from 'primevue/checkbox'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
import Toast from 'primevue/toast'
import InputMask from 'primevue/inputmask'
import accountMasterDialog from '../accountDialog/AccountMasterDialog'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import TextArea from 'primevue/textarea'
export default {
  name: 'Credit Note Entry',
  props: ['creditNote'],
  data() {
    return {
      name: '',
      pdc: false,
      englishDateEnabled: true,
      transactionDate: null,
      narration: '',
      account: '',
      txnAmountDr: 0,
      txnAmountCr: 0,
      narration3: '',
      drCr: '',
      drtotal: 0,
      crTotal: 0,
      difference: 0,
      chequeDate: null,
      chequeNumber: '',
      transactionDetailDTOList: [],
      transactionDeleteList: [],
      bank: false,
      editing: false,
      voucherNo: null,
      editDTO: false,
      index: null,
      tranId: null,
      tranModuleType: null,
      loading: false,
      cheque: false,
      filteredAccounts: null
    }
  },
  computed: {
    // voucherNo() {
    //   return this.$store.state.accounting.voucherNo
    // },
    accountMasterList() {
      return this.$store.state.accounting.accountList
    },
    calculation() {
      let difference = 0
      this.drtotal = 0
      this.crTotal = 0
      for (let i = 0; i < this.transactionDetailDTOList.length; i++) {
        if (this.transactionDetailDTOList[i].drCr === 'D') {
          this.drtotal += parseFloat(this.transactionDetailDTOList[i].txnAmount)
        } else {
          this.crTotal += parseFloat(this.transactionDetailDTOList[i].txnAmount)
        }
        difference = parseFloat(this.drtotal) - parseFloat(this.crTotal)
      }
      return difference
    }
  },
  mounted() {
    if (this.creditNote === undefined) {
      this.maxVoucherNo()
    }
    this.accountList()
    if (this.creditNote !== undefined) {
      this.editjournal()
    }
    this.checkEnglish()
    if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.state.isEnglishDateEnabled && this.creditNote === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
  },
  methods: {
    set_account_master(data) {
      this.account = data
    },
    async maxVoucherNo() {
      let response = await this.$store.dispatch('maxVoucherNoCreditNote')
      if (this.creditNote === undefined) {
        this.voucherNo = response.data.data
        this.narration = response.data.message + '- ' + response.data.data
      } else {
        this.voucherNo
        this.narration
      }
    },
    async accountList() {
      await this.$store.dispatch('accountMasterList')
    },
    addTransactionToDTO() {
      if (this.account === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select account!', life: 10000})
        return
      } else if (this.txnAmountDr <= 0 && this.txnAmountCr <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please enter amount!', life: 10000})
        return
      }
      if (this.account.id === undefined) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please Select valid account!', life: 10000})
        return
      }
      if (this.txnAmountDr > 0) {
        this.drCr = 'D'
        this.txnAmount = this.txnAmountDr
      } else {
        this.txnAmount = this.txnAmountCr
        this.drCr = 'C'
      }
      this.checkForChequeDate()
      let transaction = {
        accountMaster: this.account,
        narration3: this.narration3,
        txnAmount: this.txnAmount,
        chequeDate: this.chequeDate,
        chequeNumber: this.chequeNumber,
        drCr: this.drCr
      }
      if (!this.editDTO) {
        this.transactionDetailDTOList.push({...transaction})
      } else {
        this.transactionDetailDTOList.splice(this.index, 1, {...transaction})
      }
      this.resetAccountDto()
      this.focusInput()
    },
    editAccountFromDTO(data, index) {
      this.resetAccountDto()
      this.editDTO = true
      this.account = data.accountMaster
      this.drCr = data.drCr
      if (this.drCr === 'D') {
        this.txnAmountDr = data.txnAmount
      } else {
        this.txnAmountCr = data.txnAmount
      }
      this.chequeNumber = data.chequeNumber
      this.chequeDate = data.chequeDate
      // this.accountMasterId = data.accountMaster.id
      this.narration3 = data.narration3
      this.index = index
    },
    async saveCreditNoteEntry() {
      let response = ''
      let creditNote = {
        transactionDate: this.transactionDate,
        narration1: this.narration,
        chequeNumber: this.chequeNumber,
        chequeDate: this.chequeDate,
        tranId: this.tranId,
        tranModuleType: this.tranModuleType,
        transactionDetailDTOList: this.transactionDetailDTOList,
        transactionDeleteList: this.transactionDeleteList
      }
      if (this.transactionDetailDTOList.length < 1) {
        this.$toast.add({severity: 'error', summary: '', detail: 'The transaction must have at least two transaction heads!', life: 10000})
        return
      }
      if (this.calculation !== 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Debit and credit amount should be equal!', life: 10000})
        return
      }
      if (!this.editing) {
        this.loading = true
        response = await this.$store.dispatch('saveCreditNoteEntry', creditNote)
        this.loading = false
      } else {
        this.loading = true
        response = await this.$store.dispatch('updateEntry', creditNote)
        this.loading = false
        this.editing = false
        this.$router.back()
      }
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        await this.maxVoucherNo()
        this.reset()
        this.focusAfterSave()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    async editjournal() {
      let response = await this.$store.dispatch('loadaccountLedger', this.creditNote)
      if (response.data.status === 'SUCCESS') {
        this.editing = !this.editing
        let resp = response.data.data
        this.voucherNo = resp.voucher
        if (!this.$store.getters.englishDate) {
          this.transactionDate = resp.transactionNepaliDate
        } else {
          this.transactionDate = resp.transactionDate
        }
        this.transactionDetailDTOList = resp.transactionDetailDTOList
        this.narration = resp.narration1
        this.tranId = resp.tranId
        this.tranModuleType = this.creditNote.tranModuleType
      }
    },
    resetAccountDto() {
      this.account = ''
      this.txnAmountDr = 0
      this.txnAmountCr = 0
      this.narration3 = ''
      this.editDTO = false
      if (this.$store.getters.englishDate) {
        this.chequeDate = new Date().toISOString().slice(0, 10)
      } else {
        this.chequeDate = this.$store.state.nepaliNewDate
      }
      this.chequeNumber = ''
    },
    deleteAccountFromDTO(data, id) {
      this.checkForChequeDate()
      if (this.$store.getters.englishDate) {
        this.chequeDate = new Date().toISOString().slice(0, 10)
      } else {
        this.chequeDate = this.$store.getters.nepaliNewDate
      }
      if (this.editing && data.id !== null) {
        this.transactionDeleteList.push({...data})
      }
      this.transactionDetailDTOList.splice(id, 1)
    },
    reset() {
      this.resetAccountDto()
      this.transactionDetailDTOList = []
      this.editing = false
      if (!this.$store.getters.englishDate) {
        this.setNepaliDate()
      } else {
        this.transactionDate = new Date().toISOString().slice(0, 10)
        this.chequeDate = new Date().toISOString().slice(0, 10)
      }
    },
    setNepaliDate() {
      if (this.creditNote === undefined) {
        this.transactionDate = this.$store.getters.nepaliNewDate
        this.chequeDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.transactionDate = new Date().toISOString().slice(0, 10)
      this.chequeDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#transactionDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.transactionDate = $('#transactionDate').val()
        }
      })
      if (this.account.isBankAccount) {
        $('#chequeDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.chequeDate = $('#chequeDate').val()
          }
        })
      } else {
        this.chequeDate = ''
      }
    },
    searchItem(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredAccounts = [...this.accountMasterList]
        } else {
          this.filteredAccounts = this.accountMasterList.filter((account) => {
            return account.name.toLowerCase().startsWith(event.query.toLowerCase())
          })
        }
      }, 250)
    },
    focusInput() {
      this.$refs.itm.focus()
    },
    focusAfterSave() {
      this.$refs.tran.focus()
    },
    goBack() {
      if (this.transactionDeleteList.length > 0) {
        this.creditNote.transactionDetailDTOList = this.transactionDeleteList
      }
      this.$router.back()
    },
    checkForChequeDate() {
      if (this.account.isBankAccount || this.account.isBankAccount === undefined) {
        if (this.account.isBankAccount) {
          this.bank = true
        } else if (this.account.isBankAccount === undefined) {
          this.bank = false
        } else if (!this.account.isBankAccount) {
          this.bank = false
        }
        if (this.chequeNumber !== '') {
          this.cheque = true
        } else if (this.chequeNumber === '') {
          this.cheque = false
        }
      }
    }
  },
  components: {
    Dropdown,
    DatePicker,
    Checkbox,
    AutoComplete,
    InputNumber,
    Toast,
    InputMask,
    accountMasterDialog,
    InputText,
    Button,
    TextArea
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">
._drcr{
  color:red;
}

</style>



// WEBPACK FOOTER //
// creditnote.vue?20376af6